<ng-container *ngIf="enabled">
  <ng-content></ng-content>
</ng-container>